import styled, { css } from 'styled-components';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.css';

export const hideNativeScrollBar = css`
  scrollbar-width: none;
  overflow-y: auto;
  overflow-x: auto;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const StyledSimpleBar = styled(SimpleBar)`
  ${({ theme: { metrics, colors } }) => css`
    .simplebar-vertical .simplebar-scrollbar::before {
      cursor: default;
      border-radius: ${metrics.rem(4)};
      background-color: ${colors.grey.light};
      width: ${metrics.rem(8)};
      left: unset;
      right: 0;
    }
    .simplebar-horizontal .simplebar-scrollbar {
      top: unset;
      bottom: 0;
    }
    .simplebar-horizontal .simplebar-scrollbar::before {
      cursor: default;
      border-radius: ${metrics.rem(4)};
      background-color: ${colors.grey.light};
      height: ${metrics.rem(8)};
      top: unset;
      bottom: 0;
    }
    .simplebar-track .simplebar-scrollbar.simplebar-visible::before {
      opacity: 1;
    }
    .simplebar-track .simplebar-scrollbar.simplebar-visible.simplebar-hover::before {
      background-color: ${colors.grey.semi};
    }
    .simplebar-container > *:only-child {
      ${hideNativeScrollBar}
    }
    .simplebar-offset > *:only-child {
      ${hideNativeScrollBar}
    }
  `}
`;
